<div class="acs-page">
  <!-- Page Header -->
  <div class="acs-page-header">
    <div class="acs-page-header__content">
      <div class="acs-page-header__title-section">
        <h1 class="acs-page-header__title">📢 Announcements</h1>
        <p class="acs-page-header__subtitle">Stay updated with the latest chapter news</p>
      </div>
    </div>
  </div>


  <!-- Data Grid -->
  <div class="acs-grid-section">
    <div class="acs-grid-section__container">
      <acs-data-grid
        [data]="announcements"
        [columns]="columns"
        [loading]="isLoading"
        [searchable]="true"
        [sortable]="true"
        [enableDropdownFilters]="true"
        [showPagination]="true"
        [pageSize]="20"
        searchPlaceholder="Search announcements..."
        emptyMessage="No announcements found. Check back later for updates from your chapter.">
      </acs-data-grid>
    </div>
  </div>

  <!-- Announcement Preview Modal -->
  <acs-modal
    *ngIf="isAnnouncementModalOpen"
    [isOpen]="isAnnouncementModalOpen"
    [title]="currentAnnouncement?.Title || 'Announcement'"
    size="large"
    (close)="closeAnnouncementModal()"
    (closed)="closeAnnouncementModal()"
    (backdropClick)="closeAnnouncementModal()">
    
    <div class="announcement-preview-container">
      <!-- Preview Header with Announcement Info -->
      <div class="preview-header" *ngIf="currentAnnouncement">
        <div class="preview-announcement-info">
          <div class="preview-priority">
            {{ utils.getPriorityIcon(currentAnnouncement.Priority) }}
          </div>
          <h3>{{ currentAnnouncement.Title }}</h3>
          <div class="preview-meta">
            <span class="preview-meta-item">
              📅 {{ utils.formatRelativeDate(currentAnnouncement.PublishDate) }}
            </span>
            <span class="preview-meta-item" *ngIf="currentAnnouncement.CreatedByUser">
              👤 Author: {{ currentAnnouncement.CreatedByUser }}
            </span>
            <span class="preview-meta-item" *ngIf="currentAnnouncement.ExpiryDate">
              ⏰ Expires {{ utils.formatDate(currentAnnouncement.ExpiryDate.toISOString()) }}
            </span>
          </div>
        </div>
      </div>

      <!-- Announcement Content -->
      <div class="preview-content">
        <div class="announcement-content" [innerHTML]="currentAnnouncement?.Content">
        </div>
      </div>
    </div>
  </acs-modal>
</div>